import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {ProductModel} from '../product.model';
import {ProductSummaryConverter} from './productSummary.converter';
import {Injectable} from '@angular/core';

@Injectable()
export class ProductConverter extends HttpModelConverter<ProductModel> {

    constructor(private summaryConverter: ProductSummaryConverter) {
        super();
    }

    protected createInstance(): ProductModel {
        return new ProductModel();
    }

    protected enrichObject(result: ProductModel, src: ProductModel) {
        result.summary = this.summaryConverter.convert(src.summary);
    }


}
